import { useState, useMemo } from 'react'
import { ChevronDown } from 'lucide-react'
import { IconPickerModal } from './IconPickerModal'
import { getIconComponent } from './iconLibraries'

interface IconPickerProps {
  value?: string
  onChange: (iconName: string) => void
  error?: string
  label?: string
}

export function IconPicker({
  value,
  onChange,
  error,
  label,
}: IconPickerProps) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const SelectedIconComponent = useMemo(() => {
    if (!value) return null
    return getIconComponent(value)
  }, [value])

  const handleSelect = (iconName: string) => {
    onChange(iconName)
  }

  return (
    <>
      <div className="w-full">
        {label && (
          <label className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
        )}
        <button
          type="button"
          onClick={() => setIsModalOpen(true)}
          className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all duration-200 flex items-center justify-between ${
            error ? 'border-red-500' : 'border-gray-300'
          } ${isModalOpen ? 'ring-2 ring-brand-500' : ''} hover:bg-gray-50`}
        >
          <div className="flex items-center gap-2 min-w-0 flex-1">
            {SelectedIconComponent && value ? (
              <>
                <SelectedIconComponent className="w-5 h-5 text-gray-600 flex-shrink-0" />
                <span className="text-gray-700 truncate">{value}</span>
              </>
            ) : (
              <span className="text-gray-400">Selecione um ícone</span>
            )}
          </div>
          <ChevronDown
            className={`w-4 h-4 text-gray-400 flex-shrink-0 transition-transform ${
              isModalOpen ? 'rotate-180' : ''
            }`}
          />
        </button>
        {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
      </div>

      <IconPickerModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSelect={handleSelect}
        selectedIcon={value}
      />
    </>
  )
}
